import { handleFetch, POST_OPTIONS } from './base.service';

const BASE_PATH = '/user';

export const loginService = async (body) => {
    return await handleFetch(`${BASE_PATH}/login`, POST_OPTIONS, body);
}